var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.25A2.75 2.75 0 016.75 6v5a.75.75 0 01-.75.75H3a2.75 2.75 0 010-5.5h2.25V6A1.25 1.25 0 004 4.75H2a.75.75 0 010-1.5h2zm11-3a.75.75 0 010 1.5h-3A1.25 1.25 0 0010.75 3v.25H13A2.75 2.75 0 0115.75 6v3A2.75 2.75 0 0113 11.75h-1A2.75 2.75 0 019.25 9V3A2.75 2.75 0 0112 .25h3zM3 7.75A1.25 1.25 0 001.75 9l.006.124A1.25 1.25 0 003 10.25h2.25v-2.5H3zM10.75 9A1.25 1.25 0 0012 10.25h1A1.25 1.25 0 0014.25 9V6A1.25 1.25 0 0013 4.75h-2.25V9z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.562c57cbee07f2f2571812ff2a870ef9.svg";
export { ForwardRef as ReactComponent };